module.exports = __webpack_public_path__ + "img/table.05c646b4.svg";